const handlePWAData = ({ appId, version, fbclid, _fbp, marketingDomain }) => {
  if (appId) {
    localStorage.setItem('appId', appId);
  }

  if (version) {
    localStorage.setItem('appVersion', version);
  }

  if (fbclid) {
    localStorage.setItem('fbclid', fbclid);
  }

  if (_fbp) {
    localStorage.setItem('_fbp', _fbp);
  }

  if (marketingDomain) {
    localStorage.setItem('marketingDomain', marketingDomain);
  }
};

export const readIframeData = () => {
  window.addEventListener('message', (event) => {
    const { type, data } = event.data || {};

    if (type === 'iframeContext' && !!data && typeof data === 'object') {
      handlePWAData(data);
    }
  });
};
